import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  generateOtpAction,
  validateOtpAction,
} from "../../redux/actions/loginAction";
import { PhoneIcon } from "../../Utils/SvgIcons";
import { getToken } from "../../Utils/types";

const ValidateOtp = () => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [seconds, setSeconds] = useState(60);

  const getRegisterMobileNumber = useSelector(
    (state) => state.globalReducer?.getRegisterMobileNumber
  );

  useEffect(() => {
    if (getToken() || getRegisterMobileNumber === "") {
      navigate("/");
    }
  }, []);
  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  }, [seconds]);

  const validateOtpButton = async (e) => {
    e.preventDefault();
    await dispatch(
      validateOtpAction(
        { mobileNumber: getRegisterMobileNumber, otp: otp },
        navigate
      )
    );
  };

  return (
    <div className="login-container">
      <div className="left-container login-left-container">
        <div className="logo">
          <img
            src="https://live.healthassure.in/ProvidersPortal/images/HealthAssureLogo1.png"
            className="login-img img-fluid"
            alt="logo"
          />
          <div className="mb-5">
            <h2 className="login-h2">Login</h2>
            <p className="login-p" style={{ marginTop: "40px" }}>
              We have sent you an OTP on
              <span> *******{getRegisterMobileNumber?.slice(6, 10)}</span>
            </p>
            <p className="login-p">Please enter the 6 digit OTP to verify</p>
          </div>
          <form>
            <div className="user-input-field">
              <input
                type="text"
                className="form-control login-input"
                maxLength={6}
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder="OTP"
                onKeyPress={(event) => {
                  const re = /[0-9]+/g;
                  if (!re.test(event.key)) {
                    event.preventDefault();
                  }
                  if (event.key === "Enter") {
                    validateOtpButton(event);
                  }
                }}
              />
            </div>
            <div>
              <button
                className="login-button"
                type="submit"
                onClick={validateOtpButton}
              >
                Sign In
              </button>
            </div>
            <div style={{ textAlign: "center" }}>
              {seconds === 0 ? (
                <p className="signup-link">
                  Didn’t Recieved OTP?
                  <a
                    href="#"
                    onClick={async () => {
                      await dispatch(
                        generateOtpAction(getRegisterMobileNumber, navigate)
                      );
                      setOtp("");
                      setSeconds(60);
                    }}
                    type="button"
                    className="ms-2"
                  >
                    Resend
                  </a>
                </p>
              ) : (
                <p className="signup-link">
                  Resend OTP in
                  <a href="#" className="ms-2">
                    {seconds < 10 ? `0${seconds}` : seconds} seconds
                  </a>
                  (seconds left)
                </p>
              )}
            </div>
          </form>
        </div>
      </div>
      <div className="right-container">
        <div className="bottom-card">
          <h2>2500+ Strong Diagnostic Partner Network across the country</h2>
          <img className="group-star" src="./images/groupstar.svg" alt="groupstar" />
          <p className="f-14">1000 + Providers are already using this Portal</p>
          <a href="tel:022-61676600" className="call-button">
            {window.innerWidth > 900 ? (
              <PhoneIcon color="white" />
            ) : (
              <PhoneIcon color="#0061fe" />
            )}
            <span style={{ fontSize: "18px" }}>022-61676600</span>
          </a>
        </div>
      </div>
    </div>
  );
};
export default ValidateOtp;
